import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import { GameAnimations } from "../..";
export default class Pick {
    constructor(pickContainer, pickFont, pickFromPSD, index) {
        this.isPicked = false;
        this.index = index;
        this.pickDisplay = pickFromPSD.phaser.display;
        this.pickDimensions = pickFromPSD.dimensions;
        this.pickSpine = this.setPickSpine();
        this.pickText = this.setPickText(pickFont);
        this.touchArea = this.touchAreaFromPSD();
        this.pickContainer = pickContainer;
        this.pickContainer.add(this.pickSpine);
        this.pickContainer.add(this.pickText);
        this.pickContainer.add(this.touchArea);
    }
    getPickSpine() {
        return this.pickSpine;
    }
    setPickSpine() {
        const spine = scene.add.spine(this.pickDisplay.x, this.pickDisplay.y, ResourcesDispatcher.SPINES.PickBonus.jsonKey, ResourcesDispatcher.SPINES.PickBonus.atlasKey).setOrigin(0.5);
        spine.animationState.addAnimation(0, 'cocktail_' + (this.index + 1) + '_idle', false);
        return spine;
    }
    enableInteraction(onPick) {
        this.touchArea.input.enabled = true;
        this.touchArea.on('pointerdown', () => {
            if (this.isPicked)
                return;
            this.isPicked = true;
            this.touchArea.input.enabled = false;
            this.pickSpine.animationState.setAnimation(0, 'cocktail_' + (this.index + 1) + '_win', true);
            onPick();
        });
    }
    getPickText() {
        return this.pickText;
    }
    setPickText(pickFont) {
        return scene.add.text(this.pickDisplay.x, this.pickDisplay.y, "", pickFont).setOrigin(0.5);
    }
    getPickContainer() {
        return this.pickContainer;
    }
    getIsPicked() {
        return this.isPicked;
    }
    setIsPicked(isPicked) {
        this.isPicked = isPicked;
    }
    getTouchArea() {
        return this.touchArea;
    }
    setTouchArea(touchArea) {
        this.touchArea = touchArea;
    }
    touchAreaFromPSD() {
        const touchArea = scene.add.graphics();
        // touchArea.lineStyle(10, 0xff0000, 1);
        touchArea.strokeRect(this.pickDisplay.x - this.pickDimensions.width / 2, this.pickDisplay.y - this.pickDimensions.height / 2, this.pickDimensions.width, this.pickDimensions.height);
        touchArea.setInteractive(new Phaser.Geom.Rectangle(this.pickDisplay.x - this.pickDimensions.width / 2, this.pickDisplay.y - this.pickDimensions.height / 2, this.pickDimensions.width, this.pickDimensions.height), Phaser.Geom.Rectangle.Contains);
        touchArea.input.cursor = 'pointer';
        touchArea.input.enabled = false;
        return touchArea;
    }
    animatePickWin(text, targetValue) {
        const startingValue = 0;
        return new Promise(resolve => {
            GameAnimations.tweenCounter(text, startingValue, targetValue, 1000, resolve);
        });
    }
}
